import { Card, Col, Input, List, Row, Tag } from "antd";
import { Typography } from "antd";

const { Text, Paragraph } = Typography;

const getRandom = (list) => {
  const index = Math.floor(Math.random() * list.length);
  return list[index];
};

const colors = ["processing", "magenta", "red", "volcano", "green", "orange"];

function WorkExperience({ experience }) {
  return (
    <Card bordered>
      <Row>
        <Col span={12} style={{ padding: 3 }}>
          <Input addonBefore="Company" value={experience.company} />
        </Col>
        <Col span={12} style={{ padding: 3 }}>
          <Input addonBefore="Position" value={experience.position} />
        </Col>
      </Row>
      <Row style={{ marginTop: 6 }}>
        <Col span={8} style={{ padding: 3 }}>
          <Input addonBefore="Location" value={experience.location} />
        </Col>
        <Col span={8} style={{ padding: 3 }}>
          <Input addonBefore="Range" value={experience.date_range} />
        </Col>
        <Col span={8} style={{ padding: 3 }}>
          <Input
            addonBefore="Experience Type"
            value={experience.experience_type}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: 6 }}>
        <Col span={16} style={{ padding: 3 }}>
          <List
            header={<Text strong>Responsibilites</Text>}
            bordered
            dataSource={experience.responsibilities}
            renderItem={(item) => (
              <List.Item>
                <Paragraph style={{ textAlign: "start", margin: 0 }}>
                  {item}
                </Paragraph>
              </List.Item>
            )}
          />
        </Col>
        <Col span={8} style={{ padding: 3 }}>
          <List
            header={<Text strong>Skills</Text>}
            bordered
            dataSource={[experience.skills_used]}
            renderItem={(item) => (
              <List.Item>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  {item.map((skill, i) => (
                    <Tag
                      style={{ margin: 2 }}
                      key={i}
                      color={getRandom(colors)}
                    >
                      {skill}
                    </Tag>
                  ))}
                </div>
              </List.Item>
            )}
          />
        </Col>
      </Row>
    </Card>
  );
}

export default WorkExperience;
